export const CLIENTS = {
  sulamerica: Number(process.env.REACT_APP_CLIENT_SULAMERICA),
  medsenior: Number(process.env.REACT_APP_CLIENT_MEDSENIOR),
  manual: Number(process.env.REACT_APP_CLIENT_MANUAL),
};
